import { bootstrapApplication } from '@angular/platform-browser';
import { RouteReuseStrategy, provideRouter, withPreloading, withHashLocation } from '@angular/router';
import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular/standalone';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { SplashScreen } from '@capacitor/splash-screen';
import { IdlePreloadStrategy } from './app/core/idle-preload.strategy';
import { apiInterceptor } from './app/core/api.interceptor';
import { analyticsInterceptor } from './app/core/interceptors/analytics.interceptor';

import { routes } from './app/app.routes';
import { AppComponent } from './app/app.component';

/**
 * Nothing is allowed to run before bootstrap.
 *
 * Bootstrap waits for every APP_INITIALIZER to settle before it constructs
 * AppComponent, and AppComponent's first line is the SplashScreen.hide() that
 * takes the native launch image down. So any initializer at all puts a native
 * splash — a launch image with a loading bar painted into it — in front of the
 * driver for as long as it takes to settle. That is what App Store review
 * rejected, and a timeout around it only shortens the freeze, it does not
 * remove it.
 *
 * There is nothing left here to wait for. The token was the only initializer,
 * and it is read in two places that actually need it: startupRedirectGuard,
 * which picks /home vs /login before the first navigation, and AppComponent,
 * which re-reads it behind whichever screen the guard picked. TokenService.init()
 * is idempotent, so reading it twice costs one extra Preferences lookup.
 */
bootstrapApplication(AppComponent, {
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideIonicAngular(),
    provideRouter(routes, withPreloading(IdlePreloadStrategy), withHashLocation()),
    provideHttpClient(
      withInterceptors([apiInterceptor, analyticsInterceptor])
    ),
  ],
}).catch(err => {
  console.error('[Bootstrap Error] Failed to initialize App:', err);
  // AppComponent never got built, so the hide() on its first line will never
  // run. Take the native splash down here or the app is stranded on it.
  void SplashScreen.hide({ fadeOutDuration: 0 }).catch(() => {});
});
